import ActionTypes from '../actions/ActionTypes';
import ImportRequestRecord from '../records/ImportRequestRecord';
const initialState = new ImportRequestRecord();
export default function importRequest(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.START_OR_CANCEL_IMPORT_PENDING:
      return state.merge({
        isRequesting: true,
        error: undefined
      });
    case ActionTypes.START_IMPORT_SUCCESS:
    case ActionTypes.CANCEL_IMPORT_SUCCESS:
      return state.merge({
        isRequesting: false,
        error: undefined,
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'number' is not assignable to type 'null | un... Remove this comment to see the full error message
        lastLoaded: new Date().valueOf()
      });
    case ActionTypes.START_OR_CANCEL_IMPORT_ERROR:
      return state.merge({
        isRequesting: false,
        error: action.error
      });
    case ActionTypes.START_OR_CANCEL_RESET:
      return initialState;
    default:
      return state;
  }
}